angular.module('eStories.cta.model', [])

    .service('CtaModel', [
        'WS',
        '$rootScope',
        '$location',
        'ModalsModel',
        'AccountModel',
        'PromoModel',
        function (WS, $rootScope, $location, ModalsModel, AccountModel, PromoModel) {
            var model = this;
            model.account = AccountModel;

            model.promo = PromoModel;

            model.ctaBehavior = null;

            model.showDefault = function () {
                return model.ctaBehavior == null;
            };

            model.showSignIn = function () {
                return model.ctaBehavior == 'signin';
            };

            model.showSignUp = function () {
                return model.ctaBehavior == 'signup';
            };

            model.searchCtaParam = function () {
                var ctaBehavior = $location.search()['CTA_behavior'];
                if (ctaBehavior) {
                    switch (ctaBehavior) {
                        case 'signin':
                        case 'signup':
                            model.ctaBehavior = $location.search()['CTA_behavior'];
                            break;
                        default :
                            model.ctaBehavior = null;
                            break;
                    }
                }
            };

            model.showSignUpModal = function () {
                ModalsModel.open('/registration/signUpModal.tmpl.html', 'RegistrationCtrl', 'regCtrl');
            };

            model.showSignInModal = function () {
                ModalsModel.open('/registration/signInModal.tmpl.html', 'RegistrationCtrl', 'regCtrl');
            };

            model.isAudiobookFree = function (audiobook) {
                if (audiobook) {
                    var pricesObj = audiobook.productList;
                    for (var i = 0; i < pricesObj.length; i++) {
                        if (pricesObj[i].nonMemberPrice == 0) {
                            return true;
                        }
                    }
                    return false;
                }
            };

            $rootScope.$on('refreshCtas', function (response) {
                if (model.promo.promoPackage !== null && model.promo.promoPackage !== undefined ) {
                    if(model.promo.promoPackage.name === 'CYBER50'){
                        if(AccountModel.hasSubscription()){
                            PromoModel.clearPromoPackage();
                            AccountModel.extraCreditSale();
                        }
                    }
                }
            });

//            TODO: ES-4806 Tech Debt: web buttons are messy and need logical infrastructure - tech debt
//            model.getPrimaryButtonText = function (audiobookObj) {
//                if (model.isAudiobookFree(audiobookObj)) {
//                    if (AccountModel.isMember()) {
//                        return 'FREE';
//                    } else {
//                        return 'FREE WITH SIGN IN/SIGN UP';
//                    }
//                }
//                if (!AccountModel.isMember()) {
//                    return model.promo.promoPackage ? model.promo.promoPackage.callToActionCopy : 'FREE WITH 30 DAY<br/>TRIAL MEMBERSHIP';
//                }
//                if (AccountModel.isMember() && !AccountModel.isPaidMember()) {
//                    if (model.account.trialType == 'basic') {
//                        return model.promo.promoPackage ? model.promo.promoPackage.callToActionCopy : 'FREE WITH 30 DAY<br/>TRIAL MEMBERSHIP';
//                    }
//                    if (model.account.trialType == 'twoMo2cdt') {
//                        return model.promo.promoPackage ? model.promo.promoPackage.callToActionCopy : '2 Months & 2 Books Free';
//                    }
//                }
////                subscriber
//                if (AccountModel.isMember() && AccountModel.isPaidMember()) {
//                    if (AccountModel.hasAvailableCredit()) {
//                        return "BUY WITH 1 CREDIT?";
//                    } else if (!AccountModel.hasAvailableCredit()) {
//                        return "BUY FOR MEMBER PRICE " + model.account.getMyAudiobookPrice(audiobookObj);
//                    }
//                }
//                if (AccountModel.isTrialMember()) {
//                    if (model.account.hasAvailableCredit()) {
//                        return 'BUY WITH 1 TRIAL CREDIT?';
//                    } else if (!model.account.hasAvailableCredit()) {
//                        return 'READY TO START YOUR PLAN?';
//                    }
//
//                }
//            };
//
//            model.getPrimaryButton = function (audiobookObj) {
//
//                if (model.isAudiobookFree(audiobookObj) && !AccountModel.isMember()) {
//                    return 'signUpOrConfirmTrial';
//                }
//
//                if (AccountModel.isMember() && model.isAudiobookFree(audiobookObj)) {
//                    return 'showPurchaseAudiobookModalRetail';
//                }
//
//                if (AccountModel.isMember() && AccountModel.hasAvailableCredit()) {
//                    return 'showPurchaseAudiobookModalCredit';
//                }
//
//                if (AccountModel.isMember() && !AccountModel.hasAvailableCredit()) {
//                    return 'showPurchaseAudiobookModalBooster';
//                } else {
//                    return 'signUpOrConfirmTrial';
//                }
//            };
//
//            model.getSecondaryButton = function (audiobook) {
//                if (AccountModel.isMember()) {
//                    return 'signUpOrConfirmTrial';
//                }
//                if (model.isAudiobookFree(audiobook)) {
//                    return '';
//                }
//            };
//
//            model.getSecondaryButtonText = function (audiobook) {
//                return "heyyyy";
//            };

        }]);
